// extracted by mini-css-extract-plugin
module.exports = {"copyResult":"styles_copyResult__mP_fE","copyButton":"styles_copyButton__G0GtY","copyIcon":"styles_copyIcon___JpI0","customView":"styles_customView__oQBj4"};